// Tooltip component scripts
// Credit: https://codepen.io/vincentnavetat/pen/JjPVzGL
(function() {
  class Tooltip extends HTMLElement {
    connectedCallback() {
      this.setup();
    }

    handleDropdownPosition() {
      const screenPadding = 0; // screen padding is moved to an actual padding value on the dropdown element using CSS
      
      this.dropdown.style = '';

      const placeholderRect = this.placeholder.getBoundingClientRect();
      const dropdownRect = this.dropdown.getBoundingClientRect();
      
      const dropdownRightX = dropdownRect.x + dropdownRect.width;
      const placeholderRightX = placeholderRect.x + placeholderRect.width;
      
      var viewportHeight;
      var viewportWidth;
      if (document.compatMode === 'BackCompat') {
          viewportHeight = document.body.clientHeight;
          viewportWidth = document.body.clientWidth;
      } else {
          viewportHeight = document.documentElement.clientHeight;
          viewportWidth = document.documentElement.clientWidth;
      }

      if (dropdownRect.x < screenPadding) {
        this.dropdown.style.left = '0';
        this.dropdown.style.right = 'auto';
        this.dropdown.style.transform = `translateX(${-placeholderRect.x + screenPadding}px)`;
      } else if (dropdownRightX > viewportWidth - screenPadding) {
        this.dropdown.style.left = 'auto';
        this.dropdown.style.right = '0';
        this.dropdown.style.transform = `translateX(${(viewportWidth - placeholderRightX) - screenPadding}px)`;
      }
    }

    toggle(e) {
      e.preventDefault();
      if (this.classList.contains('tooltip--open')) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.handleDropdownPosition();
      this.classList.add('tooltip--open');
    }

    close() {
      this.classList.remove('tooltip--open');
    }

    setup() {
      this.placeholder = this.querySelector('[data-tooltip-target]');
      this.dropdown = this.querySelector('[data-tooltip-element]');

      this.placeholder.addEventListener('mouseover', () => this.handleDropdownPosition());
      this.placeholder.addEventListener('click', (e) => this.toggle(e));
    }
  }

  function dismissAllTooltips(event) {
    if (typeof event.target.closest !== 'function') return;
    const currentTooltip = event.target.closest('tooltip-component');

    document.querySelectorAll('.tooltip--open').forEach(tooltip => {
      if (tooltip === currentTooltip) return;

      tooltip.classList.remove('tooltip--open');
    });
  }

  customElements.define('tooltip-component', Tooltip);
  document.addEventListener('click', e => dismissAllTooltips(e));
})();

// Update the Mystery Gift hidden property when the selected variant changes
(function() {
  function formatPriceFromCents(cents) {
    if (typeof cents !== 'number') return '';
    return (cents / 100).toFixed(2); // "12.00"
  }

  window.addEventListener('shopify-variants:switch-variant', function(event) {
    let detail = event && event.detail;
    if (!detail) return;
    let variant = detail.variant;
    if (!variant) return;

    // Choose the value you'd like to set:
    
    if (formatPriceFromCents(variant.price) < 2000) {
      var newValue = Properties.MysteryGift[0];
    } else if (formatPriceFromCents(variant.price) >= 2000 && formatPriceFromCents(variant.price) < 3000) {
      var newValue = Properties.MysteryGift[1];
    } else if (formatPriceFromCents(variant.price) >= 3000) {
      var newValue = Properties.MysteryGift[2];
    }

    // Update any Mystery Gift inputs in product forms on the page
    document.querySelectorAll('[data-product-form]').forEach(function(formEl) {
      var giftInput = formEl.querySelector('input[name="properties[Mystery Gift]"]');
      if (giftInput) {
        giftInput.value = newValue;
      }
    });
  }, { passive: true });
})();